

import React, { useEffect, useRef, useState } from 'react';
import './FeaturesComponent.scss';
import {
  FaUsers,
  FaClipboardCheck,
  FaChair,
  FaChartBar,
  FaWineBottle,
  FaGlobeAmericas,
} from 'react-icons/fa';

const FEATURES = [
  { title: 'Add & organize guests by family', icon: FaUsers },
  { title: 'Collect RSVPs online', icon: FaClipboardCheck },
  { title: 'Assign tables & seating easily', icon: FaChair },
  { title: 'Track real-time stats (attending, pending, not attending)', icon: FaChartBar },
  { title: 'Track liquor preferences', icon: FaWineBottle },
  { title: 'Modern wedding website for your guests', icon: FaGlobeAmericas },
];

const FeaturesComponent = () => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // Reveal-on-scroll
  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.2 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`features ${visible ? 'is-visible' : ''}`}
      id="features"
      aria-label="What we offer"
    >
      <div className="features__head">
        <p className="features__eyebrow">Our Features</p>
        <h2 className="features__title">What we offer?</h2>
        <p className="features__lead">
          Everything you need to plan your guest experience with elegance and ease.
        </p>
      </div>

      <ul className="features__grid">
        {FEATURES.map(({ title, icon: Icon }, i) => (
          <li className="feature" key={i}>
            <span className="feature__badge" aria-hidden="true">
              {/* Bold icon via react-icons, sized for presence */}
              <Icon className="feature__icon" />
            </span>
            <h3 className="feature__title">{title}</h3>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default FeaturesComponent;
